import { createSlice } from "@reduxjs/toolkit";

export const featureSettingSlice = createSlice({
  name: "featureSetting",
  initialState: {
    replace_courier_link: "1",
    add_link_to_order: "0",
    link_description: "",
    form_noti_email: "0",
    tracking_page_step: "1",
    notification_step: "1",
    analytic_step: "1",
    get_order_step: "0",
    email_step: "1",
    is_ask: "2",
    courier_settings: null,
    first_visit: "1",
    order_lookup: null,
    synctrack_status: "1",
    synctrack_secret: "",
    fb_messenger_status: "0",
    theme_version: "1",
    update_scope: "1",
    enabled_edd: null,
    timezone: "-05",
  },
  reducers: {
    setFeatureSetting: (state, action) => {
      const featureSetting = action.payload;
      return featureSetting;
    },
  },
});

export const { setFeatureSetting } = featureSettingSlice.actions;

export default featureSettingSlice.reducer;
